import { Icon } from "web/components"
import classNames from "classnames"

export default function Selections({
  value = [],
  inputTestId,
  onRemoveItem,
  deactivated,
}) {
  const itemsToDisplay = value.map((x) => x.label)

  if (itemsToDisplay.length === 0) return null

  const selectionClasses = classNames(
    "z-30 mt-1.5 mr-1.5 grid place-items-center justify-between gap-x-1.5 rounded-md bg-primary-10 p-1.5 text-xs font-bold text-primary-1",
    {
      "opacity-50": deactivated,
    }
  )

  return (
    <div
      className="m-0 flex w-full flex-wrap whitespace-normal"
      data-testid={`${inputTestId}-items`}
    >
      {itemsToDisplay.map((item, i) => (
        <div
          key={i}
          className={selectionClasses}
          style={{ gridTemplateColumns: "1fr auto" }}
        >
          {item}
          {deactivated ? (
            <Icon name="x-mark" width="15px" height="15px" />
          ) : (
            <Icon
              name="x-mark"
              width="15px"
              height="15px"
              className="cursor-pointer"
              onClick={(e) => {
                e.stopPropagation()
                onRemoveItem(i)
              }}
            />
          )}
        </div>
      ))}
    </div>
  )
}
